import dynamic from "next/dynamic";

//FIXME: This uses next/dynamic and should live in /next, but Sanity currently uses it to render Icons.
import { MultiColorIconSelections } from "@brexhq/shared/types/MultiColorIcons";

const allMultiColoredIcons: Record<
  typeof MultiColorIconSelections[number],
  any
> = {
  Airtable: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Airtable"),
  ),
  Amazon: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Amazon"),
  ),
  BrexPrideLogoBlack: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/BrexPrideLogoBlack"),
  ),
  BrexPrideLogoWhite: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/BrexPrideLogoWhite"),
  ),
  Deel: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Deel")),
  Doordash: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Doordash"),
  ),
  Expensify: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Expensify"),
  ),
  Gusto: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Gusto")),
  MoneyCard: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/MoneyCard"),
  ),
  Netsuite: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Netsuite"),
  ),
  Number1: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Number1"),
  ),
  Number2: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Number2"),
  ),
  Number3: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Number3"),
  ),
  PayPal: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/PayPal"),
  ),
  QuickBooks: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/QuickBooks"),
  ),
  Rippling: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Rippling"),
  ),
  Robinhood: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Robinhood"),
  ),
  Sap: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Sap")),
  ScaleAi: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/ScaleAi"),
  ),
  Shopify: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Shopify"),
  ),
  SpendBatterRechargeWellness: dynamic(
    () =>
      import(
        "@brexhq/shared/assets/icons/multicolor/SpendBatterRechargeWellness"
      ),
  ),
  SpendBill: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendBill"),
  ),
  SpendBillPay: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendBillPay"),
  ),
  SpendBrexFlag: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendBrexFlag"),
  ),
  SpendCard: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendCard"),
  ),
  SpendCash: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendCash"),
  ),
  SpendChatSupport: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendChatSupport"),
  ),
  SpendClosingBooks: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendClosingBooks"),
  ),
  SpendCreditJourney: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendCreditJourney"),
  ),
  SpendCustomPolicyEdit: dynamic(
    () =>
      import("@brexhq/shared/assets/icons/multicolor/SpendCustomPolicyEdit"),
  ),
  SpendEducationGraduation: dynamic(
    () =>
      import("@brexhq/shared/assets/icons/multicolor/SpendEducationGraduation"),
  ),
  SpendExtraRewardsPoints: dynamic(
    () =>
      import("@brexhq/shared/assets/icons/multicolor/SpendExtraRewardsPoints"),
  ),
  SpendFlexibleLimits: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendFlexibleLimits"),
  ),
  SpendHandshake: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendHandshake"),
  ),
  SpendHeart: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendHeart"),
  ),
  SpendHigherLimits: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendHigherLimits"),
  ),
  SpendLock: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendLock"),
  ),
  SpendMapPin: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendMapPin"),
  ),
  SpendMegaphone: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendMegaphone"),
  ),
  SpendMilesTravel: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendMilesTravel"),
  ),
  SpendOptimizeSpend: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendOptimizeSpend"),
  ),
  SpendOptions: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendOptions"),
  ),
  SpendPersonalGuarantee: dynamic(
    () =>
      import("@brexhq/shared/assets/icons/multicolor/SpendPersonalGuarantee"),
  ),
  SpendPremium: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendPremium"),
  ),
  SpendReceiptMatching: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendReceiptMatching"),
  ),
  SpendRequest: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendRequest"),
  ),
  SpendRewardsPoints: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendRewardsPoints"),
  ),
  SpendRocketFast: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendRocketFast"),
  ),
  SpendShield: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendShield"),
  ),
  SpendTransfersWires: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendTransfersWires"),
  ),
  SpendYield: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/SpendYield"),
  ),
  Stripe: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Stripe"),
  ),
  Superhuman: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Superhuman"),
  ),
  ThumbsUp: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/ThumbsUp"),
  ),
  Xero: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Xero")),
  YCombinator: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/YCombinator"),
  ),
  Android: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/Android"),
  ),
  BrexDarkLogo: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/BrexDarkLogo"),
  ),
  BrexWhiteLogo: dynamic(
    () => import("@brexhq/shared/assets/icons/multicolor/BrexWhiteLogo"),
  ),
  Card: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Card")),
  Carta: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Carta")),
  Coin: dynamic(() => import("@brexhq/shared/assets/icons/multicolor/Coin")),
};

export default allMultiColoredIcons;
